export function calculateTotalGst(gstData) {
    let totalGst = 0;

    gstData.forEach(data => {
        const { amt } = data;
        const igst = amt?.i || 0; 
        const cgst = amt?.c || 0; 
        const sgst = amt?.s || 0; 
        totalGst += parseFloat(igst) + parseFloat(sgst) + parseFloat(cgst); 
    });

    return totalGst;
}
export const extractGstData = (info) => {
    return info.map(item => {
        if (item?.gstFullData) {
            return item.gstFullData; 
        } 
        if (item?._id) {
            return item._id;
        } 
        return { amt: {} }; 
    });
  };
  
  export const calculateTotalBaseAmount = (gstArray,taxableAmount) => {
    return gstArray.reduce((total, item) => {
        const baseAmount = parseFloat(item?.bsAmt || taxableAmount)
        return total + (baseAmount || 0); 
    }, 0);
  };

export const getOptionDataOnEdit = (formOptionsList,editId, type) => {
    const data = formOptionsList.find(
      (item) => item?._id === editId && item.typ === type
    );
    return data;
  };